import { NavLink } from "react-router-dom";
import {
  getManualTestingClusterPage,
  manualClusterInternalLinks,
} from "../content/manualTestingCluster";
import "../style/manualTestingCluster.css";

export default function ManualTestingClusterPage({ slug }) {
  const page = getManualTestingClusterPage(slug);

  if (!page) {
    return null;
  }

  return (
    <article className="manual-cluster-page">
      <div className="manual-cluster-intro">
        <span>Manual Testing Cluster</span>
        <p>
          This guide is part of QA Coder&apos;s manual testing SEO cluster. Use it
          with the related pages to build a complete beginner-to-interview path.
        </p>
      </div>

      {page.sections.map((section) => (
        <section className="manual-cluster-section" id={section.id} key={section.id}>
          <h2>{section.heading}</h2>

          {section.paragraphs?.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}

          {section.list && (
            <ul>
              {section.list.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}

          {section.faqs && (
            <div className="manual-cluster-faq">
              {section.faqs.map((faq) => (
                <details key={faq.question}>
                  <summary>{faq.question}</summary>
                  <p>{faq.answer}</p>
                </details>
              ))}
            </div>
          )}
        </section>
      ))}

      <section className="manual-cluster-links" aria-label="Related QA Coder learning links">
        <h2>Continue learning</h2>
        <p>
          Build stronger topical authority by connecting manual testing with automation,
          API testing, and interview preparation.
        </p>
        <div>
          {manualClusterInternalLinks.map((link) => (
            <NavLink to={link.to} key={link.to}>
              {link.label}
            </NavLink>
          ))}
        </div>
      </section>
    </article>
  );
}
